// src/routes/humanResourceRoutes.js
import HumanResourceNav from "../../pages/Dashboard/HumanResource/HumanResourceNav";
import HumanResourceIndex from "../../pages/Dashboard/HumanResource/HumanResourceIndex";
import EmployeeLeave from "../../pages/Dashboard/HumanResource/EmployeeLeave/EmployeeLeave";
import EmployeesList from "../../pages/Dashboard/HumanResource/Employees/EmployeesList/EmployeesList";
import Evaluation from "../../pages/Dashboard/HumanResource/Evaluation/Evaluation";
import PositionsIndex from "../../pages/Dashboard/HumanResource/Postisons/PositionsIndex";
import DepartmentsIndex from "../../pages/Dashboard/HumanResource/Departments/DepartmentsIndex";
import AttendanceReport2 from "../../pages/Dashboard/HumanResource/Attendance/AttendanceReport2";
import EmployeeAdd from "../../pages/Dashboard/HumanResource/Employees/EmployeeAdd/EmployeeAdd";
import EmployeeEdit from "../../pages/Dashboard/HumanResource/Employees/EmployeeEdit/EmployeeEdit";
import Backup from "../../pages/Dashboard/HumanResource/backup/Backup";
import AssetList from "../../pages/Dashboard/HumanResource/Asset/AssetList";
import NightShiftPlanning from "../../pages/Dashboard/NightShift/NightShiftPlanning";
import DriversList from "../../pages/Dashboard/HumanResource/Drivers/DriversList/DriversList";

const humanResourceRoutes = {
  path: "/human-resource",
  element: <HumanResourceNav />,
  children: [
    { index: true, element: <HumanResourceIndex /> },
    { path: "attendance", element: <AttendanceReport2 /> },
    { path: "departments", element: <DepartmentsIndex /> },
    { path: "employee-leave", element: <EmployeeLeave /> },
    { path: "employees", element: <EmployeesList /> },
    { path: "employees/add", element: <EmployeeAdd /> },
    { path: "employees/edit", element: <EmployeeEdit /> },
    { path: "evaluation", element: <Evaluation /> },
    { path: "positions", element: <PositionsIndex /> },
    { path: "backup", element: <Backup /> },
    { path: "asset", element: <AssetList /> },
    { path: "night-shift-planning", element: <NightShiftPlanning /> },
    { path: "drivers", element: <DriversList /> },
  ],
};

export default humanResourceRoutes;
